/** @format */
import React from 'react';

export const entEVR = {
  service: 'Baby Sitter',
  dove: 'Nome della zona indicata',
  costo: 'Per un costo non superiore a:  ',
  prezzo: <strong>€12.00</strong>,
  orario: 'Servizio da erogare  ',
  day: <strong>nel pomeriggio</strong>,
  mansioni: [
    {
      work: '- Accudimento e vigilanza',
    },
    {
      work: "- Cura dell'igiene",
    },
    {
      work: '- Aiuto nel lavarsi e vestirsi',
    },
    {
      work: '- Gioco e intrattenimento in casa e fuori casa',
    },
    {
      work: '- Preparazione e somministrazione di pappa e/o pasti',
    },
    {
      work: '- Aiuto nello svolgimento dei compiti',
    },
  ],
  periodo: 'Dal 1/04/2019 Al 30/04/2019',
  note: 'Note aggiuntive',
};
